'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokCrossSellSliderType } from '../../storyblok'
import { StoryblokRecommendationSliderRenderer } from '../StoryblokRecommendation/StoryblokRecommendationSliderRenderer'

export const StoryblokCrossSellSlider: FC<
  StoryblokComponentProps<StoryblokCrossSellSliderType>
> = ({ blok }) => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Storyblok content may predate the recommendation field migration.
  if (!blok.areaId || !blok.serviceId) {
    return null
  }

  return (
    <StoryblokRecommendationSliderRenderer
      editableProps={storyblokEditable(blok)}
      serviceId={blok.serviceId}
      widgetId={blok.areaId}
    />
  )
}
